module.exports = __webpack_public_path__ + "static/img/4_1.2c9a2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/4_1.png
// module id = 5O6P
// module chunks = 1